import { MapPin, Mail, Phone } from 'lucide-react';
import AnimatedSection from '@/components/ui/AnimatedSection';
import { UTA_CONFERENCE_SCHEDULE_TEXT } from '@/lib/eventTimes';

export default function LocationSection() {
    return (
        <section className="py-24 bg-gray-50">
            <div className="container mx-auto px-6">
                <div className="flex flex-col lg:flex-row gap-8 bg-white rounded-2xl shadow-xl overflow-hidden">

                    {/* Map */}
                    <div className="w-full lg:w-3/5 h-[400px] lg:h-auto bg-gray-200 relative">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2553.567890123456!2d5.496!3d50.352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c05b8c0c0c0c0c%3A0x0!2sParc%20de%20Juliénas%201%2C%206940%20Barvaux-sur-Ourthe!5e0!3m2!1sfr!2sbe!4v1600000000000!5m2!1sfr!2sbe"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Parc de Juliénas 1, Barvaux-sur-Ourthe"
                            className="grayscale hover:grayscale-0 transition-all duration-500"
                        ></iframe>
                    </div>

                    {/* Info */}
                    <div className="w-full lg:w-2/5 p-12 flex flex-col justify-center">
                        <AnimatedSection>
                            <h3 className="text-3xl font-serif font-bold text-primary-900 mb-6">Nous trouver</h3>

                            <div className="space-y-6">
                                <div className="flex items-start gap-4">
                                    <div className="p-3 bg-primary-50 rounded-lg text-primary-600">
                                        <MapPin size={24} />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 mb-1">Nos Locaux</h4>
                                        <p className="text-gray-600">
                                            Parc de Juliénas 1<br />
                                            6940 Barvaux-sur-Ourthe<br />
                                            (Durbuy)
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4">
                                    <div className="p-3 bg-primary-50 rounded-lg text-primary-600">
                                        <Mail size={24} />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 mb-1">Email</h4>
                                        <a href="mailto:daniellemottet47@gmail.com" className="hover:text-primary-600 transition-colors">
                                            daniellemottet47@gmail.com
                                        </a>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4">
                                    <div className="p-3 bg-primary-50 rounded-lg text-primary-600">
                                        <Phone size={24} />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 mb-1">Téléphone</h4>
                                        <p className="text-gray-600">
                                            0479 99 21 23
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8 p-4 bg-accent-50 border border-accent-100 rounded-lg text-sm text-accent-800">
                                <strong>Horaires :</strong> {UTA_CONFERENCE_SCHEDULE_TEXT}
                            </div>
                        </AnimatedSection>
                    </div>

                </div>
            </div>
        </section>
    );
}
